import ContentHeading from "@/components/content-heading";
import { useTranslation, Trans } from "react-i18next";
// Tailwind CSS
import { wrapper, headingItem, heading, content } from "./styles/hero";

const Hero: React.FC = () => {
    const { t } = useTranslation();
    return (
        <section className={wrapper} title={"hearX Group vision, mission and value statement"} aria-label={"White background with hearX vision, mission and value statement"}>
            <div className={headingItem}>
                <div className={heading}>
                    <ContentHeading
                        h="p"
                        className="justify-end"
                        backdropPosition="left-4"
                        fontSize="mobile:text-2xl tablet:text-5xl"
                        background="bg-primary bg-opacity-40"
                    >
                        {t("who-we-are.hero.vision.heading")}
                    </ContentHeading>
                </div>
                <div className={content}>
                    <p>
                        <Trans components={{ br: <br /> }}>who-we-are.hero.vision.content</Trans>
                    </p>
                </div>
            </div>
            <div className={headingItem}>
                <div className={heading}>
                    <ContentHeading
                        h="p"
                        className="justify-end"
                        backdropPosition="left-4"
                        fontSize="mobile:text-2xl tablet:text-5xl"
                        background="bg-primary bg-opacity-40"
                    >
                        {t("who-we-are.hero.mission.heading")}
                    </ContentHeading>
                </div>
                <div className={content}>
                    <p>
                        <Trans components={{ br: <br /> }}>who-we-are.hero.mission.content</Trans>
                    </p>
                </div>
            </div>
            <div className={headingItem}>
                <div className={heading}>
                    <ContentHeading
                        h="p"
                        className="justify-end"
                        backdropPosition="left-4"
                        fontSize="mobile:text-2xl tablet:text-5xl"
                        background="bg-primary bg-opacity-40"
                    >
                        {t("who-we-are.hero.value.heading")}
                    </ContentHeading>
                </div>
                <div className={content}>
                    <p>
                        <Trans components={{ br: <br /> }}>who-we-are.hero.value.content</Trans>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Hero;
